import { deleteApiWithData, getApi, postApi } from 'apis';
import { SideDrawerWrapper } from 'components/Global';
import { PaginationProps, TableProps } from 'antd';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import CustomTable from './CustomTable';
import styles from './index.module.scss';
import AddCompanyBody from './AddCompanyBody';


const ComapanyTable = () => {

	// State variables
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(
		Number(localStorage.getItem('userTableSize')) || 10
	);
	const [filter, setFilter] = useState('');
	const [sort, setSort] = useState('');
	const [type, setType] = useState('asc');
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Users',
	});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editSelectedCompany, setEditSelectedCompany] = useState<any>();
	const [totalUsers, setTotalUsers] = useState(0);
	const [companyData, setCompanyData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [isSearchCancel, setIsSearchCancel] = useState<boolean>(false);



	const removeDrawerFromDom = () => {
		setSideDrawerOpen(false);
	};

	const openDrawerHandler = () => {
		setDrawerInfo({ drawerTitle: 'Add Company' });
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};


	const closeDrawerByAnimation = () => {
		setEditSelectedCompany(undefined); 
		setDrawerAnimation(false);
	};


	const performSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearch(value);
		setPage(1);
		if(value.length > 0){
			setIsSearchCancel(true)
		}else{
			setIsSearchCancel(false)
		}
	};


	const showModal = () => {
		setIsModalOpen(true);
	};

	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setEditSelectedCompany(null);
	};

	const handleCancel = () => {
		setIsModalOpen(false); // !isAddUserLoading &&
		setEditSelectedCompany(null);
	};

	// // Delete user
	// const deleteHandler = async () => {
	// 	if (editSelectedCompany) {
	// 		try {
	// 			setIsDeleteLoading(true);
	// 			const resp = await deleteApiWithData('/user', { deleteUserId: editSelectedCompany.userCompanyRoleId });
	// 			toastText(resp?.data?.message ?? 'User deleted successfully', 'success');
	// 		} catch (error: any) {
	// 			toastText(error.response?.data?.message ?? 'Something went wrong in delete user', 'error');
	// 		} finally {
	// 			setIsDeleteLoading(false);
	// 			handleCancel();
	// 			fetchCompaines();
	// 		}
	// 	}
	// };


		// Delete user
		const deleteHandler = async () => {
			if (editSelectedCompany) {
				try {
					const data: any = companyData.filter(
						(company: any) => company.id !== editSelectedCompany.id
					);
	
					setIsDeleteLoading(true);
					await deleteApiWithData('/company', {
						companyId: editSelectedCompany.id,
					});
					handleCancel();
					try {
						const company = await postApi('/company', {
							companyId: data[0].id,
						});
						localStorage.setItem(
							'accessToken',
							company.data.accessToken
						);
						window.location.reload();
					} catch (err) {
						console.log('ERRR: ', err);
					}
				} catch (error) {
					toastText('Something went wrong in delete company', 'error');
				} finally {
					setIsDeleteLoading(false);
				}
			}
		};
	const reinviteUserAction = async (data: any) => {
		setIsLoading(true);
		try {
			await postApi('/user/reinvite-user', {
				reInviteUserId: data.userId,
			});
			toastText('User re-invited successfully', 'success');
		} catch (error) {
			toastText('Something went wrong in re-inviting user', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const fetchCompaines = useCallback(async () => {
		setIsLoading(true);
		const query = {
			page: page,
			pageSize: limit,
			search: search,
			sortBy: sort,
			sortOrder: type
		};
		const res = await getApi('/company', query);
		setCompanyData(res?.data?.data);
		setIsLoading(false);
		setTotalUsers(res?.data?.total);
	}, [page, limit, search, type, sort, filter]);

	const handleTableChange: TableProps<any>['onChange'] = (
		pagination,
		filters,
		sorter
	) => {
		const sortOrder = Array.isArray(sorter)
			? sorter[0]?.order
			: sorter.order === 'ascend'
				? 'asc'
				: 'desc';
		setType(sortOrder as string);

		const sortField = Array.isArray(sorter)
			? sorter[0]?.field
			: sorter.field === 'name'
				? 'name'
				: sorter.field;
		setSort(sortField as string);
	};

	const onShowSizeChange: PaginationProps['onShowSizeChange'] = (
		current,
		pageSize
	) => {
		setPage(current);
		setLimit(pageSize);
	};


	useEffect(() => {
		fetchCompaines();
	}, [limit, page, search, sort, type, filter]);

	// JSX
	return (
		<>
			<div className={styles['user-table']}>
				{/* <TableActionHeader title={'Users'}>
				</TableActionHeader> */}

				<CustomTable
					dataSource={companyData}
					handleTableChange={handleTableChange}
					onShowSizeChange={onShowSizeChange}
					isLoading={isLoading}
					search={search}
					totalRecords={totalUsers}
					performSearchHandler={performSearchHandler}
					performFilterHandler={(value: any) => setFilter(value)}
					reinviteUserAction={reinviteUserAction}
					openDrawerHandler={openDrawerHandler}
					setDrawerInfoHandler={setDrawerInfoHandler}
					setEditSelectedCompany={setEditSelectedCompany}
					showModal={showModal}
					currentPage={page}
					pageSize={limit}
					isSearchCancel={isSearchCancel}
					setIsSearchCancel={setIsSearchCancel}
					setSearch={setSearch}
				/>
			</div>
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading} //isLoading
			// isAddUserLoading={false} //isAddUserLoading
			/>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddCompanyBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						editSelectedCompany={editSelectedCompany}
						setEditSelectedCompany={setEditSelectedCompany}
						fetchCompaines={fetchCompaines}
					/>
				</SideDrawerWrapper>
			)}
		</>
	);
};

export default ComapanyTable;
